import React, { useEffect, useState, useCallback } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  Loading,
  BankSelect,
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import NoAccess from "../NoAccess";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import EditIcon from '@mui/icons-material/Edit';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

/* TRANSACTION STATUS


Available
Issued
Cleared
Cancelled
Bounced
Stale


*/

export default function GLAccounts() {
  const [view, setView] = useState("Main");
  const [mainData, setMainData] = useState(null);



//#region UI
  return (
    <>
      { view === "Main" ? <MainView 
                            view={view} setView={setView} 
                            mainData={mainData} setMainData={setMainData} 
                          />
        : view === "Sub" ? <SubMainView 
                                        view={view} setView={setView}
                                        mainData={mainData} setMainData={setMainData} 
                                      />
        : <></>
      }
    </>
  );
//#endregion
}








function MainView({
  view, setView,
  mainData, setMainData,
}) {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.bankName.toLowerCase().includes(lowerValue) ||
        item.accountNumber.toLowerCase().includes(lowerValue) ||
        item.id.toString().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion




//#region Variables
  const [selectedData, setSelectedData] = useState(null);
  const [bank, setBank] = useState(null);
  const [description, setDescription] = useState("");
  const [code, setCode] = useState("");
  const [snStart, setSNStart] = useState(0);
  const [snEnd, setSNEnd] = useState(0);

  const resetVariables = () => {
    setBank(null);
    setDescription("");
    setCode("");
    setSNStart(0);
    setSNEnd(0);
  }
//#endregion




// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  const handleAddData = async () => {
    const data = {
      bankId: bank?.id,
      description: description,
      code: code,
      snStart: snStart,
      snEnd: snEnd,
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/Checkbook`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion




// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Checkbook/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
      
      return response.data
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);

  const editHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setBank(_data?.bank ?? null);
    setDescription(_data?.description ?? "");
    setCode(_data?.code ?? "");
    setSNStart(_data?.snStart ?? "");
    setSNEnd(_data?.snEnd ?? "");

    openUpdateForm();
    setLoading(false);
  }

  const handleUpdateData = async () => {
    const data = {
      bankId: bank?.id,
      description: description,
      code: code,
      snStart: snStart,
      snEnd: snEnd,
      updatedBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.put(`${apiUrl}/api/Checkbook/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion





// #region Transaction function
  const openTransactionForm = () => {
    setView("Sub")
  }

  const transactionHandleClick = async (data) => {
    setLoading(true)

    const _data = data;
    setMainData(_data)
    openTransactionForm();

    setLoading(false)
  }
//#endregion




//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'ID', 
    'BANK', 
    'DESCRIPTION', 
    'CODE', 
    'SN START', 
    'SN END', 
    'CURRENT #', 
    'ACTIONS',
  ]
  const accessors = [
    'id', 
    'bankName', 
    'description', 
    'code', 
    'snStart', 
    'snEnd', 
    'currentNumberFormat', 
    'actions'
  ]

  const actions = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    },
    { 
      name: "Transaction", 
      tooltip: "transactions",
      icon: <AccountBalanceWalletIcon fontSize="small" />,
      className: "bg-orange-500 hover:bg-orange-600",
      function: transactionHandleClick,
      visible: true,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/Checkbook` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData])
//#endregion




//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasCheckbook) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <MenuBookIcon fontSize="large" className="text-theme-color" />
              {`Checkbook (${data?.length ?? 0})`}
            </h2>
            <p className="text-gray-500 mt-1">Collection of checks.</p>
          </div>
          <div className="flex gap-3">
            <button onClick={openAddForm} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New Checkbook
            </button>
          </div>
        </div>

        {/* Search and Filters */}
        <div className="flex justify-between items-center gap-2">
          <div className="mb-4 w-full">
            <input
              type="text"
              placeholder="Search by bank or ID..."
              className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
            {/* Add filter dropdowns here if needed */}
          </div>
        </div>

        <CreateTable
          tableName={"Checkbook"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Data"}

        data={data}
        bank={bank} setBank={setBank}
        description={description} setDescription={setDescription}
        code={code} setCode={setCode}
        snStart={snStart} setSNStart={setSNStart}
        snEnd={snEnd} setSNEnd={setSNEnd}
      />

      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Data"}

        data={data}
        bank={bank} setBank={setBank}
        description={description} setDescription={setDescription}
        code={code} setCode={setCode}
        snStart={snStart} setSNStart={setSNStart}
        snEnd={snEnd} setSNEnd={setSNEnd}
        isUpdate={true}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}




















//#region SubMain View
function SubMainView({
  view, setView,
  mainData, setMainData,
}) {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
//#endregion










//#region Variables
  /* const [selectedData, setSelectedData] = useState(null);

  const resetLocalVariables = () => {
    setSelectedData(null);
  } */
//#endregion










// #region Update function
  /* const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetLocalVariables();
  }

  const editHandleClick = async (data) => {
    setLoading(true)
    
    setSelectedData(data);

    setLoading(false)
    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const data = {
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/SalesInvoicePayment/update/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  }  */
//#endregion


















//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'CHECKBOOK NO', 
    // 'REFERENCE TYPE', 
    'REFERENCE NO', 
    'AMOUNT', 
    'TRANSACTED BY', 
    'TRANSACTION DATE', 
    'STATUS', 
    // 'ACTIONS',
  ]
  const accessors = [
    'checkbookNumber', 
    // 'referenceType', 
    'referenceNumber', 
    'amount', 
    'transactedByUser', 
    'transactionDate', 
    'status', 
    // 'actions'
  ]

  const actions = [
    /* { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    }, */
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/Checkbook/transaction/main-data/${mainData?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [mainData]);

  useEffect(() => {
    if(view === "Sub"){
      fetchData();
    }
  }, [view, fetchData])
//#endregion















//#region Back
const backToAllList = () => {
  setView("Main")
  setMainData(null)
}
//#endregion









//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasChartOfAccounts) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <button 
          onClick={backToAllList}
          className="group flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors mb-4"
        >
          <div className="p-2 rounded-full group-hover:bg-gray-100 transition-all">
            <ArrowBackIcon fontSize="small" />
          </div>
          Back to All List
        </button>

        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
              <AccountBalanceWalletIcon fontSize="large" className="text-theme-color" />
              {mainData?.description}
            </h2>
          </div>
        </div>

        <CreateTable
          tableName={"GL Account"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}
//#endregion









//#region AddUpdate Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  bank, setBank,
  description, setDescription,
  code, setCode,
  snStart, setSNStart,
  snEnd, setSNEnd,
  isUpdate
}) => {
  const [failMessage, setFailMessage] = useState("");

  const [showBankSelectForm, setShowBankSelectForm] = useState(false);
  const openBankSelectForm = () => {
    setShowBankSelectForm(true);
  }
  const closeBankSelectForm = () => {
    setShowBankSelectForm(false);
  }

  if (!visible) return null;

  const handleSubmit = async () => {
    // Validation check
    if (!bank || !description || !code || !snStart || !snEnd) {
      setFailMessage("Please fill up required field/s.");
      return;
    }
    await onSave();
    closeModal();
  };

  const closeModal = () => {
    setFailMessage("");
    onClose();
  };

  return (
    <>
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-900 bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
            >
              {/* Header */}
              <div className="px-8 py-5 border-b border-gray-300">
                <h2 className="text-2xl font-semibold text-gray-800">
                  {modalName}
                </h2>
              </div>

              
              <div className="p-8 overflow-y-auto custom-scrollbar">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {!isUpdate && 
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Bank <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Bank"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={bank?.bankName || ""}
                          readOnly
                        />
                        {!bank ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openBankSelectForm}>
                            <ManageSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setBank(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                  }
                  
                  <div>
                    <label className="block text-sm font-medium mb-1 text-gray-700">
                      Description <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. CHECKBOOK #1"
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>

                  {!isUpdate && 
                    <>
                      <div>
                        <label className="block text-sm font-medium mb-1 text-gray-700">
                          Code <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="e.g. ABC"
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={code}
                          onChange={(e) => setCode(e.target.value)}
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1 text-gray-700">
                          SN Start <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="number"
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={snStart}
                          onChange={(e) => setSNStart(e.target.value)}
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1 text-gray-700">
                          SN End <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="number"
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={snEnd}
                          onChange={(e) => setSNEnd(e.target.value)}
                        />
                      </div>
                    </>
                  }
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end space-x-3 p-6 border-t border-gray-300 bg-gray-50">
                <button
                  onClick={closeModal}
                  className="px-6 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-200 transition font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-8 py-2 rounded-lg bg-theme-color text-white font-semibold hover:opacity-90 transition shadow-md"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <BankSelect
        visible={showBankSelectForm}
        onClose={closeBankSelectForm}
        modalName={"Select Bank"}
        data={bank} // full current data array
        setData={setBank}
      />

      <div className="fixed top-5 right-5 z-[9999]">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion














